"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isKeysDiffer = void 0;
const tslib_1 = require("tslib");
const lodash_1 = tslib_1.__importDefault(require("lodash"));
function isKeysDiffer(firstObj, secondObj) {
    return lodash_1.default.differenceWith(Object.keys(firstObj), Object.keys(secondObj))
        .length > 0;
}
exports.isKeysDiffer = isKeysDiffer;
//# sourceMappingURL=is-keys-differ.js.map